import { Box} from "@aksara-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";

import {
  getTotalMembersAlfamart,
  getTotalOcrTempClaimed,
  getTotlOcrAlfamartAmount,
  getTotalUserByCity,
  getTotalOcrByCity,
  getTotalUserRegistration, 
  getTotalRedeem,
  getTotalOcrPerDay,
} from "redux/actions";

import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ArcElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const UltraRewardContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });
 
  useEffect(() => {
    dispatch(getTotalMembersAlfamart() as any);
    dispatch(getTotalOcrTempClaimed() as any);
    dispatch(getTotlOcrAlfamartAmount() as any);
    dispatch(getTotalUserByCity() as any);
    dispatch(getTotalOcrByCity() as any);
    dispatch(getTotalRedeem() as any);
    dispatch(getTotalUserRegistration() as any);
    dispatch(getTotalOcrPerDay() as any);
  }, [dispatch]);

  // const reportUrl = "https://lookerstudio.google.com/embed/reporting/d46bc2e7-d9ac-41b3-bf11-a9a36956387c/page/p_8oob8frfod";
  
  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>

    </Box>
  );
};

export default UltraRewardContent;


